// src/ui/DevToolsButton/ui/ExperimentsSection/ExperimentsSection.tsx
import { FC } from "react"
import {
  EXPERIMENTS,
  ExperimentKey,
  debugExperiments,
  useExperiment
} from "utils/debugExperiments"
import styles from "./ExperimentsSection.module.scss"

const ToggleRow: FC<{ k: ExperimentKey }> = ({ k }) => {
  const value = useExperiment(k)
  return (
    <label className={styles.row}>
      <span>{EXPERIMENTS[k].label}</span>
      <input
        type="checkbox"
        checked={value}
        onChange={(e) => debugExperiments.set(k, e.target.checked)}
      />
    </label>
  )
}

export const ExperimentsSection: FC = () => {
  return (
    <div className={styles.section}>
      <div className={styles.title}>Experiments</div>
      {(Object.keys(EXPERIMENTS) as ExperimentKey[]).map((k) => (
        <ToggleRow key={k} k={k} />
      ))}
      <button
        type="button"
        className={styles.resetBtn}
        onClick={() => debugExperiments.resetAll()}
      >
        Reset all
      </button>
    </div>
  )
}
